import React from 'react';
import SmoothScroll from './components/SmoothScroll';
import HeroSequence from './components/HeroSequence';
import ImageTransition from './components/ImageTransition';
import ServicesIntro from './components/ServicesIntro';
import FinalMessage from './components/FinalMessage';
import '@questlabs/react-sdk/dist/style.css';

function App() {
  return (
    <SmoothScroll>
      <main className="bg-brand-light selection:bg-brand-accent selection:text-white">
        <HeroSequence />
        <ImageTransition />
        <ServicesIntro />
        <FinalMessage />
      </main>
    </SmoothScroll>
  );
}

export default App;